/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { PermissionsListFragmentDoc } from "../../mutations/permissions.generated";
import { SafeCollectionHexLinkFragmentDoc } from "../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHexForShareDialogQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  getSharedComponentCount: Types.Scalars["Boolean"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetHexForShareDialogQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly allowEmbedding: boolean;
    readonly allowPublicDuplication: boolean;
    readonly maxGrantableRole: Types.ProjectRole | null;
    readonly canShare: boolean;
    readonly canEditorsShare: boolean;
    readonly canAllowEditorsToShare: boolean;
    readonly canRevokeNotionPreviews: boolean;
    readonly effectiveRole: Types.ProjectRole | null;
    readonly publicRoleV2: Types.ProjectRole | null;
    readonly organizationRoleV2: Types.ProjectRole | null;
    readonly hasNotionPreviews: boolean;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
    readonly owner: { readonly __typename: "User"; readonly id: c.UserId };
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
    readonly org: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly displayName: string;
      readonly resolvedAllowPublicSharing: boolean;
      readonly allowWorkspaceSharing: boolean;
      readonly allowParameterizedLinkSharing: boolean;
      readonly hasCustomAppIcon: boolean;
      readonly supportUserId: c.UserId | null;
      readonly sharedComponentCount?: number;
    };
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly version: c.HexVersionString;
      readonly layoutType: Types.LayoutType | null;
      readonly canvasLayout: {
        readonly __typename: "CanvasLayout";
        readonly id: c.CanvasLayoutId;
        readonly width: number;
        readonly height: number;
      };
    } | null;
    readonly collectionHexLinks: ReadonlyArray<{
      readonly __typename: "CollectionHexLink";
      readonly id: c.CollectionHexLinkId;
      readonly projectRole: Types.ProjectRole | null;
      readonly collection: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly canManage: boolean;
        readonly name: string;
        readonly emoji: string | null;
        readonly description: string | null;
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
  readonly publicOrgDetails: {
    readonly __typename: "PublicOrgDetails";
    readonly displayName: string;
    readonly memberCount: number;
  } | null;
};

export const GetHexForShareDialogDocument = /*#__PURE__*/ gql`
  query GetHexForShareDialog(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $getSharedComponentCount: Boolean!
    $orgId: OrgId!
  ) {
    hexById(hexId: $hexId) {
      id
      allowEmbedding
      allowPublicDuplication
      maxGrantableRole
      canShare
      canEditorsShare
      canAllowEditorsToShare
      canRevokeNotionPreviews
      effectiveRole
      owner {
        id
      }
      grants {
        ...PermissionsListFragment
      }
      publicRoleV2
      organizationRoleV2
      hasNotionPreviews
      isShared
      logicViewIsShared
      org {
        id
        displayName
        resolvedAllowPublicSharing
        allowWorkspaceSharing
        allowParameterizedLinkSharing
        hasCustomAppIcon
        supportUserId
        sharedComponentCount @include(if: $getSharedComponentCount)
      }
      lastPublishedVersion {
        id
        version
        layoutType
        canvasLayout {
          id
          width
          height
        }
      }
      collectionHexLinks: safeCollectionHexLinks {
        id
        ...SafeCollectionHexLinkFragment
      }
    }
    publicOrgDetails(orgId: $orgId) {
      displayName
      memberCount
    }
  }
  ${PermissionsListFragmentDoc}
  ${SafeCollectionHexLinkFragmentDoc}
`;

/**
 * __useGetHexForShareDialogQuery__
 *
 * To run a query within a React component, call `useGetHexForShareDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexForShareDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexForShareDialogQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      getSharedComponentCount: // value for 'getSharedComponentCount'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetHexForShareDialogQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  > &
    (
      | { variables: GetHexForShareDialogQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  >(GetHexForShareDialogDocument, options);
}
export function useGetHexForShareDialogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  >(GetHexForShareDialogDocument, options);
}
export function useGetHexForShareDialogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexForShareDialogQuery,
    GetHexForShareDialogQueryVariables
  >(GetHexForShareDialogDocument, options);
}
export type GetHexForShareDialogQueryHookResult = ReturnType<
  typeof useGetHexForShareDialogQuery
>;
export type GetHexForShareDialogLazyQueryHookResult = ReturnType<
  typeof useGetHexForShareDialogLazyQuery
>;
export type GetHexForShareDialogSuspenseQueryHookResult = ReturnType<
  typeof useGetHexForShareDialogSuspenseQuery
>;
export type GetHexForShareDialogQueryResult = Apollo.QueryResult<
  GetHexForShareDialogQuery,
  GetHexForShareDialogQueryVariables
>;
